<template>
  <div>
    <b-form-group :label="trans('background_color')">
      <b-input-group class="color-picker-input">
        <ColorPicker
          :organization="organization"
          v-model="localBackgroundColor"
          show-palette
          style="width: auto"
        />
        <b-input-group-append>
          <b-button
            variant="outline-secondary"
            @click="resetColor"
            v-b-tooltip.hover
            style="background-color: #fff;"
          >
            <i class="fa fa-undo"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </div>
</template>
<style>
.form-group .color-picker-input .sp-replacer {
  width: 200px;
  padding: 0;
  margin-right: -20px;
  border-radius: 4px;
}

.form-group .color-picker-input .sp-replacer .sp-preview {
  width: 100% !important;
  height: 40px !important;
  border: 1px solid #92a0b9;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin: 0;
  padding: 0;
}
</style>
<script>
import ColorPicker from './../../../common/components/ColorPicker'

export default {
  props: {
    organization: {
      type: Object,
    },
    type: {
      type: String,
    },
    value: {
      type: String,
    },
    template: {
      type: Object,
      default: () => ({})
    },
  },
  components: {
    ColorPicker
  },
  data() {
    return {
      trans: trans,
      localBackgroundColor: this.value || this.template.content_background_color || '#ffffff'
    }
  },
  methods: {
    resetColor() {
      this.localBackgroundColor = this.template.content_background_color || '#ffffff'
    }
  },
  watch: {
    value(newVal) {
      this.localBackgroundColor = newVal || this.template.content_background_color
    },
    localBackgroundColor(newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
